const LOADING_SAVING_DATA = "LOADING_SAVING_DATA";
const SUCCESS_PRESENTATION_DATA = "SUCCESS_PRESENTATION_DATA";
const LOADING_PRESENTATION_DATA = "LOADING_PRESENTATION_DATA";

export const SavePresentationTypes = {
  LOADING_SAVING_DATA,
  SUCCESS_PRESENTATION_DATA,
  LOADING_PRESENTATION_DATA
};
